import { string, func, bool } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import { popupContainer, popupLocation, closeButton, contentContainer } from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const SearchPointPopup = ({ locationName = null, isStartingPoint, addToRoute, onClose }) => {
  const strings = StringConstantsMixin.strings.MAP_CREATOR;
  const buttonText = isStartingPoint ? strings.START_HERE : strings.ADD_TO_ROUTE;

  return (
    <div className={popupContainer}>
      <div className={contentContainer}>
        {locationName && <div className={popupLocation}>{locationName}</div>}
        <button className={closeButton} type="button" label={strings.CLOSE_POPUP} onClick={onClose} />
      </div>
      <Button text={buttonText} onClick={addToRoute} testId={buttonText} variant="primary" />
    </div>
  );
};

export default SearchPointPopup;

SearchPointPopup.propTypes = {
  onClose: func.isRequired,
  addToRoute: func.isRequired,
  isStartingPoint: bool.isRequired,
  locationName: string
};

SearchPointPopup.defaultProps = {
  locationName: null
};
